"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _utils = require("./utils.js");
var _useDebounce = require("use-debounce");
var _ChartSettings = _interopRequireDefault(require("./ChartSettings.js"));
var _ChartTypeField = _interopRequireDefault(require("./ChartTypeField.js"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Settings = function Settings(props) {
  var currentMetric = props.currentMetric,
    currentMetricSettings = props.currentMetricSettings,
    currentCrossMetric = props.currentCrossMetric,
    updateMetricSettings = props.updateMetricSettings,
    cleanCurrentMetricVizData = props.cleanCurrentMetricVizData,
    metrics = props.metrics,
    groupComparisonOptions = props.groupComparisonOptions;
  var debouncedUpdateMetricSettings = (0, _useDebounce.useDebouncedCallback)(function (metric, values) {
    updateMetricSettings(metric, values);
  }, 200);
  var chartTypes = (0, _react.useMemo)(function () {
    return (0, _utils.getChartTypes)({
      metric: currentMetric,
      metricSettings: currentMetricSettings,
      crossMetric: currentCrossMetric
    });
  }, [currentMetric, currentMetricSettings, currentCrossMetric]);
  var compareWithOptions = (0, _utils.getCrosstabComparisonOptions)(metrics, currentMetric);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].title
  }, "Settings"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].form
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: currentMetricSettings,
    onAnyChange: function onAnyChange(values) {
      return debouncedUpdateMetricSettings(currentMetric, values);
    },
    onSubmit: function onSubmit() {},
    render: function render(_ref) {
      var values = _ref.values,
        setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "comparison",
        label: "Comparison",
        component: _cccisdFormik.CccisdSelect,
        options: (0, _utils.getComparisonOptions)(currentMetric).filter(function (opt) {
          return opt.value !== 'grouptype' || groupComparisonOptions.length > 0;
        }),
        onChange: function onChange(e) {
          var value = e.target.value;
          if (value === 'crosstab') {
            var firstElement = compareWithOptions.find(function (item) {
              return !item.disabled;
            });
            if (!firstElement) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: 'No metric to compare'
              });
            } else {
              cleanCurrentMetricVizData();
              setFieldValue('comparison', value);
              setFieldValue('compareWith', firstElement ? firstElement.value : '');
            }
          } else if (value === 'grouptype') {
            cleanCurrentMetricVizData();
            var _firstElement = groupComparisonOptions[0];
            setFieldValue('comparison', value);
            setFieldValue('compareByGroupType', _firstElement ? _firstElement.value : '');
          } else {
            cleanCurrentMetricVizData();
            setFieldValue('comparison', value);
          }
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "visualizeAs",
        label: "Visualize as",
        component: _cccisdFormik.CccisdSelect,
        options: (0, _utils.getVisualizeAsOptions)({
          metric: currentMetric,
          metricSettings: currentMetricSettings,
          crossMetric: currentCrossMetric
        })
      }), values.comparison === 'crosstab' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "compareWith",
        label: "Compare With",
        component: _cccisdFormik.CccisdSelect,
        options: compareWithOptions
      }), values.comparison === 'grouptype' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "compareByGroupType",
        label: "Compare By",
        component: _cccisdFormik.CccisdSelect,
        options: groupComparisonOptions
      }), chartTypes.length > 0 && /*#__PURE__*/_react["default"].createElement(_ChartTypeField["default"], {
        chartTypes: chartTypes
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartSettings
      }, /*#__PURE__*/_react["default"].createElement(_ChartSettings["default"], {
        name: "nivoOptions",
        type: values.chartType,
        data: []
        // data={formattedData}
        // showSummaryStatsToggle={
        //     // eslint-disable-next-line no-restricted-globals
        //     !isNaN(data[selectedMetric]?.min) || !isNaN(data[selectedMetric]?.max)
        // }
      })));
    }
  })));
};

Settings.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  updateMetricSettings: _propTypes["default"].func,
  cleanCurrentMetricVizData: _propTypes["default"].func,
  metrics: _propTypes["default"].array,
  groupComparisonOptions: _propTypes["default"].array
};
var _default = Settings;
exports["default"] = _default;